import React, { Fragment } from "react";
import { Trans } from "@lingui/macro";

import SchemaSet from "components/schema-set/schema-set";
import SEO from "components/seo/seo";
import HreflangControlled from "blocks/hreflang/hreflang-controlled";
import useDocumentationThemeSlug from "hooks/use-documentation-theme-slug";
import TealBox from "components/teal-box/teal-box";
import FormTopicSearch from "blocks/form-topic-search/form-topic-search";
import Useful from "components/useful/useful";
import Sidebar from "components/sidebar/sidebar";
import Link from "components/link/link";
import Breadcrumbs from "blocks/breadcrumbs/breadcrumbs";
import Markdown from "components/markdown/markdown";
import IconSetComponent from "./page-doc-icon-set";

const PageDocSlug = ({ data }: any) => {
  const {
    categories,
    current,
    iconSet,
    iconGroups,
    globalData,
    helpData,
    locale,
    app,
  } = data;
  const hreflangs = useDocumentationThemeSlug(current);

  return (
    <Fragment>
      <HreflangControlled localizations={hreflangs} />
      <SEO data={current.attributes.SEO} />
      <SchemaSet
        schemaData={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: current.attributes.Title,
          text: current.attributes.Content,
        }}
      />
      <TealBox center maxWidth="544px">
        <h3 className="ta-c">{helpData?.attributes.title}</h3>
        <FormTopicSearch locale={locale} />
      </TealBox>
      <div className="container container--small">
        <Breadcrumbs omitIndexList={[2, 4]} />
        <div className="side-content">
          <h4 className="side-content__title">
            <Trans>Documentation</Trans>
          </h4>
          <div className="side-content__flex">
            <Sidebar
              app={app}
              categories={categories}
              current={current}
              sublinks
              global={globalData}
            />
            <div className="content">
              <div className="content_item">
                <h5>{current.attributes.Title}</h5>
                <Markdown content={current.attributes.Content} />
                {iconSet && (
                  <IconSetComponent iconSet={iconSet} iconGroups={iconGroups} />
                )}
                <Link
                  href={globalData.attributes.ContactLink}
                  className="btn btn--grey mobile-only"
                  OpenInNewTab={globalData.attributes.OpenInNewTab}
                  RelNoFollow={globalData.attributes.RelNoFollow}
                >
                  <Trans>Contact Us</Trans>
                </Link>
              </div>
              <Useful
                path={`/documentations/${current.id}`}
                global={globalData}
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default PageDocSlug;
